import React from "react";
import { Helmet } from "react-helmet";

import Header from "./header";
import Footer from "./footer";
import "./style.css";

interface LayoutProps {
  children: React.ReactNode;
  logo: string;
  footerData: string;
  logoAlt: string;
  pageTitle?: string;
  metaContent?: string;
  metaName?: string;
}

const Layout = (props: LayoutProps) => (
  <div className="layout-body-container">
    <Helmet>
      <title>{props.pageTitle}</title>
      <meta name={"title"} content={props.pageTitle} />
      <meta name={props.metaName} content={props.metaContent} />
    </Helmet>
    <Header logo={props.logo} logoAlt={props.logoAlt} />
    <div className="layout-body">{props.children}</div>
    <Footer logo={props.logo} data={props.footerData} logoAlt={props.logoAlt} />
  </div>
);

export default Layout;
